export class DisposeBag {
  private disposables: Set<() => void> = new Set();

  add(disposable: () => void): void {
    this.disposables.add(disposable);
  }

  dispose(): void {
    this.disposables.forEach((disposable) => {
      try {
        disposable();
      } catch (error) {
        console.error("Dispose error:", error);
      }
    });
    this.disposables.clear();
  }

  // 체이닝을 위한 메서드 (함수 또는 객체 모두 받을 수 있음)
  disposed(disposable: (() => void) | { dispose: () => void }): DisposeBag {
    if (typeof disposable === "function") {
      this.add(disposable);
    } else {
      this.add(disposable.dispose);
    }
    return this;
  }
}
